import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'
import fans from './routes/fans'
import news from './routes/news'
import other from './routes/other'
import recommendBuy from './routes/recommendBuy'
import user from './routes/user'
import invite from './routes/invite'
import maintenance from './routes/maintenance'
import activity from './routes/activity'
import authentication from './routes/authentication'
import jiachongzhuang from './routes/jiachongzhuang'
import makeanappointment from './routes/makeanappointment'
import car from './routes/car'
import zhuanti from './routes/zhuanti'
import newActivity from './routes/newActivity'
const routes = [
  ...fans,
  ...news,
  ...other,
  ...recommendBuy,
  ...user,
  ...invite,
  ...maintenance,
  ...activity,
  ...authentication,
  ...jiachongzhuang,
  ...makeanappointment,
  ...car,
  ...zhuanti,
  ...newActivity,

  // 异常页面
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue'),
    meta: {
      title: '页面不存在',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 从客户端获取用户信息
  if (!store.state.userInfo.loaded) {
    store.dispatch('getUserInfo').then(() => {
      next()
    })
  } else {
    next()
  }
})

export default router
